/* eslint-disable prefer-rest-params */
'use es6';

function toInteger(argument) {
  // eslint-disable-next-line no-cond-assign
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? Math.floor : Math.ceil)(argument);
}

function toAbsoluteIndex(index, length) {
  const integer = toInteger(index);
  return integer < 0 ? Math.max(integer + length, 0) : Math.min(integer, length);
}

function toLength(argument) {
  return argument > 0 ? Math.min(toInteger(argument), 0x1fffffffffffff) : 0; // 2 ** 53 - 1 == 9007199254740991
}

function requireObjectCoercible(it) {
  // eslint-disable-next-line eqeqeq
  if (it == undefined) throw TypeError(`Can't call method on ${it}`);
  return it;
}

function toObject(argument) {
  return Object(requireObjectCoercible(argument));
} // https://github.com/zloirock/core-js


export default function fill(value
/* , start = 0, end = @length */
) {
  const O = toObject(this);
  const length = toLength(O.length);
  const argumentsLength = arguments.length;
  let index = toAbsoluteIndex(argumentsLength > 1 ? arguments[1] : undefined, length);
  const end = argumentsLength > 2 ? arguments[2] : undefined;
  const endPos = end === undefined ? length : toAbsoluteIndex(end, length);

  while (endPos > index) O[index++] = value;

  return O;
}